import { Box, Grid, TextField, Typography } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import React from "react";

const filterStyle = {
  "& .MuiInputBase-input": {
    padding: "7px",
    borderRadius: "14px",
    fontSize: "14px",
    border: "none",
  },
  "& .css-1yq5fb3-MuiButtonBase-root-MuiIconButton-root": {
    color: "#673C8E",
  },
  "& .MuiOutlinedInput-root": {
    borderRadius: "14px",
  },
  "& .MuiOutlinedInput-root fieldset": {
    border: "2px solid #673C8E",
  },
  "& .MuiOutlinedInput-root fieldset:hover": {
    borderColor: "#673C8E",
  },
  "& .MuiOutlinedInput-root.Mui-focused fieldset": {
    borderColor: "#673C8E",
  },
};

function RegularOfferFIlter({ selectedFilters, setSelectedFilters }) {
  return (
    <>
      <Grid item xs={12}>
        <Typography
          sx={{
            color: "rgba(23, 26, 31, 1)",
            fontSize: "10px",
            mb: 1,
            fontWeight: 700,
          }}
        >
          Start Date
        </Typography>

        {/* FROM DATE */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 2,
          }}
        >
          <Typography
            sx={{
              color: "rgba(23, 26, 31, 1)",
              fontSize: "12px",
              mb: 1,
            }}
          >
            From:
          </Typography>
          <Box>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                format="DD MMM YYYY"
                slotProps={{
                  textField: {
                    placeholder: "DD MMM YYYY",
                  },
                }}
                value={
                  selectedFilters?.startfrom
                    ? dayjs(selectedFilters.startfrom)
                    : null
                }
                onChange={(newValue) => {
                  const formattedDate = dayjs(newValue).format("YYYY-MM-DD");
                  setSelectedFilters((prev) => ({
                    ...prev,
                    startfrom: formattedDate,
                  }));
                }}
                sx={filterStyle}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>
          </Box>
        </Box>

        {/* TO DATE */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 2,
          }}
        >
          <Typography
            sx={{
              color: "rgba(23, 26, 31, 1)",
              fontSize: "12px",
              mb: 1,
            }}
          >
            To:
          </Typography>
          <Box sx={{ width: "80%", mt: 1 }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                format="DD MMM YYYY"
                slotProps={{
                  textField: {
                    placeholder: "DD MMM YYYY",
                  },
                }}
                value={
                  selectedFilters?.startto
                    ? dayjs(selectedFilters.startto)
                    : null
                }
                onChange={(newValue) => {
                  const formattedDate = dayjs(newValue).format("YYYY-MM-DD");
                  setSelectedFilters((prev) => ({
                    ...prev,
                    startto: formattedDate,
                  }));
                }}
                sx={filterStyle}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>
          </Box>
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Typography
          sx={{
            color: "rgba(23, 26, 31, 1)",
            fontSize: "10px",
            mb: 1,
            fontWeight: 700,
          }}
        >
          Expiry Date
        </Typography>

        {/* FROM DATE */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 2,
          }}
        >
          <Typography
            sx={{
              color: "rgba(23, 26, 31, 1)",
              fontSize: "12px",
              mb: 1,
            }}
          >
            From:
          </Typography>
          <Box>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                format="DD MMM YYYY"
                slotProps={{
                  textField: {
                    placeholder: "DD MMM YYYY",
                  },
                }}
                value={
                  selectedFilters?.endfrom
                    ? dayjs(selectedFilters.endfrom)
                    : null
                }
                onChange={(newValue) => {
                  const formattedDate = dayjs(newValue).format("YYYY-MM-DD");
                  setSelectedFilters((prev) => ({
                    ...prev,
                    endfrom: formattedDate,
                  }));
                }}
                sx={filterStyle}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>
          </Box>
        </Box>

        {/* TO DATE */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 2,
          }}
        >
          <Typography
            sx={{
              color: "rgba(23, 26, 31, 1)",
              fontSize: "12px",
              mb: 1,
            }}
          >
            To:
          </Typography>
          <Box sx={{ width: "80%", mt: 1 }}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                format="DD MMM YYYY"
                slotProps={{
                  textField: {
                    placeholder: "DD MMM YYYY",
                  },
                }}
                value={
                  selectedFilters?.endto ? dayjs(selectedFilters.endto) : null
                }
                onChange={(newValue) => {
                  const formattedDate = dayjs(newValue).format("YYYY-MM-DD");
                  setSelectedFilters((prev) => ({
                    ...prev,
                    endto: formattedDate,
                  }));
                }}
                sx={filterStyle}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>
          </Box>
        </Box>
      </Grid>
    </>
  );
}

export default RegularOfferFIlter;
